import { useState } from 'react';
import '../main.css';
import './neenor.css';
import NeeNorDetails from './NeeNorDetails';
import NeeNorList from './NeeNorList';

const Neenor = () => {
  const [neeNors, setNeeNors] = useState([{ '': '' }]);
  const [selectedNeenor, setSelectedNeenor] = useState();
  const [editCreate, setEditCreate] = useState();
  const updateNeenor = (key, value) => {
    setSelectedNeenor((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  return (
    <>
      {!selectedNeenor ? (
        <NeeNorList
          neeNors={neeNors}
          setNeeNor={setSelectedNeenor}
          setNeeNors={setNeeNors}
          setEditCreate={setEditCreate}
        />
      ) : (
        <NeeNorDetails
          neenor={selectedNeenor}
          updateNeeNor={updateNeenor}
          back={() => {
            setSelectedNeenor();
          }}
          editCreate={editCreate}
        />
      )}
    </>
  );
};

export default Neenor;
